var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"16","y":"16","width":"124","height":"167","fill":"#D8D8D8","key":1})]);
}

Flag.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Flag;

Flag.default = Flag;
